var map = {
	"./en/Aplicacoes_Moveis-EN.png": 9274,
	"./en/Aplicacoes_WEB-EN.png": 2447,
	"./en/Assistencia_Informatica_a_Empresas-EN.png": 1572,
	"./en/Car-Share-EN.png": 1870,
	"./en/Certificacao_de_Empresas-EN.png": 6507,
	"./en/Consultoria_Informatica-EN.png": 3655,
	"./en/Contactos-EN.png": 4793,
	"./en/Embedded_recruitment-EN.png": 4849,
	"./en/Faturacao_para_Bancos-EN.png": 3612,
	"./en/Gestao_de_Assembleia_de_Acionistas-EN.png": 6097,
	"./en/Gestao_de_Assiduidade-EN.png": 3494,
	"./en/Gestao_de_Creditos-EN.png": 1973,
	"./en/Gestao_de_Papel_Comercial-EN.png": 1867,
	"./en/Gestao_de_Projetos-EN.png": 3788,
	"./en/Homepage-EN.png": 6090,
	"./en/Jobs-EN.png": 8780,
	"./en/Outsourcing_em_Informatica-EN.png": 9161,
	"./en/Parc-EN.png": 2754,
	"./en/RGPC-EN.png": 5712,
	"./en/Reserva_de_Salas_de_Reuniao-EN.png": 1092,
	"./en/Servico_deImplementacao_do_RGPD-EN.png": 8145,
	"./en/Smeap-EN.png": 508,
	"./en/Software_a_Medida-EN.png": 2540,
	"./pt/Aplicacoes_Moveis-PT.png": 8842,
	"./pt/Aplicacoes_WEB-PT.png": 9090,
	"./pt/Assistencia_Informatica_a_Empresas-PT.png": 7464,
	"./pt/Car-Share-PT.png": 203,
	"./pt/Certificacao_de_Empresas-PT.png": 208,
	"./pt/Consultoria_Informatica-PT.png": 3935,
	"./pt/Contactos-PT.png": 7490,
	"./pt/Embedded_recruitment-PT.png": 2218,
	"./pt/Faturacao_para_Bancos-PT.png": 905,
	"./pt/Gestao_de_Assembleia_de_Acionistas-PT.png": 1943,
	"./pt/Gestao_de_Assiduidade-PT.png": 3235,
	"./pt/Gestao_de_Creditos-PT.png": 1201,
	"./pt/Gestao_de_Papel_Comercial-PT.png": 7778,
	"./pt/Gestao_de_Projetos-PT.png": 9764,
	"./pt/Homepage-PT.png": 752,
	"./pt/Jobs-PT.png": 7826,
	"./pt/Outsourcing_em_Informatica-PT.png": 4823,
	"./pt/Parc-PT.png": 3575,
	"./pt/RGPC-PT.png": 2904,
	"./pt/Reserva_de_Salas_de_Reuniao-PT.png": 7281,
	"./pt/Servico_deImplementacao_do_RGPD-PT.png": 9262,
	"./pt/Smeap-PT.png": 1396,
	"./pt/Software_a_Medida-PT.png": 9330
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5053;